{"messages":{"previous":"Nazad","next":"Dalje","today":"Danas","month":"Mesec","week":"Nedelja","list":"Lista","day":"Dan"}}